import { v4 as uuidv4 } from "uuid";

export const createClientMutationId = (): string => {
  return uuidv4();
};
